import { atom } from 'jotai';
import { Language } from '../i18n';
export const $Locale = atom({
    language: Language.en,
});
$Locale.debugLabel = '$Locale';
